import { PubSub } from '@dinosband/dbi-utils'

export const RouterEvent = new PubSub()